import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';
import { AppComfirmComponent } from './app-confirm.component';

interface confirmData {
  title?: string;
  message?: string;
  yesText?: string;
  alternateYes?: string;
}

@Injectable()
export class AppConfirmService {
  constructor(
    private dialog: MatDialog,
    private translate: TranslateService
  ) {}

  public confirm(data: confirmData = {}): Observable<number> {
    data.title = data.title || this.translate.instant('Global.Confirm');
    data.message = data.message || this.translate.instant('Global.AreYouSure');

    let dialogRef: MatDialogRef<AppComfirmComponent>;
    dialogRef = this.dialog.open(AppComfirmComponent, {
      width: data.alternateYes ? '512px' : '380px',
      disableClose: true,
      data: {
        title: data.title,
        message: data.message,
        yesText: data.yesText,
        alternateYes: data.alternateYes,
      },
    });
    return dialogRef.afterClosed();
  }

  public confirmSessionExpulsion(): Observable<boolean> {
    let dialogRef: MatDialogRef<AppComfirmComponent>;
    dialogRef = this.dialog.open(AppComfirmComponent, {
      width: '380px',
      disableClose: true,
      data: {
        dialogName: 'sessionExpulsion',
      },
    });
    return dialogRef.afterClosed();
  }
}
